import { render, staticRenderFns } from "./TravelInconveniences.vue?vue&type=template&id=cbb9d22e&"
import script from "./TravelInconveniences.vue?vue&type=script&lang=js&"
export * from "./TravelInconveniences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports